import { useEffect, useContext } from 'react';
import { Header, Footer } from './components/export'
import { Outlet, ScrollRestoration } from 'react-router-dom'
import { fetchCartItemsByUserIdAsync } from './features/Cart/Cart_Slice';
import { useSelector, useDispatch } from 'react-redux';
import { loggedInUser } from './features/Auth/Auth_Slice';
import { fetchLoggedInUserAsync } from './features/User/userSlice';
import FullPageLoader from "./components/Common/FullPageLoader";
import NotificationContext from './context/Notification/NotificationContext';
import { isLoadingAuth, validateTokenInitiallyAsync } from './features/Auth/Auth_Slice';
import { Toaster } from 'react-hot-toast'
import { fetchItemsInUserWishlistAsync } from './features/User/userSlice';
import { motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';


function App() {
  const dispatch = useDispatch();
  const location = useLocation();
  const user = useSelector(loggedInUser);
  const isLoading = useSelector(isLoadingAuth);

  //Context
  const { displayNotification } = useContext(NotificationContext); //Alert Context


  useEffect(() => { //When app load we will add a flag isUserLoggedIn or not based on this we will show the protected route or not
    dispatch(validateTokenInitiallyAsync()).then((response) => {
      if (response.payload?.status === "error") {
        displayNotification("Unauthorized Attempt!", response.payload.message, "error");
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
    if (user) {
      dispatch(fetchCartItemsByUserIdAsync())
      dispatch(fetchLoggedInUserAsync()) // backend will extract the token from cookie
      /*for wishlist i have 2 approach 
      1. when user open i will the request to the server and check for that particular item is in userWishlist or not
      2. when user login fetchAll the wishlist item and compare locally instead of making request again and again
      that's why i'll fetch all the wishlist when user logged in
      */
      dispatch(fetchItemsInUserWishlistAsync())
    }
  }, [dispatch, user])
  return (
    <>
      {isLoading && <FullPageLoader />}
      <Header />
      <Toaster position="bottom-center" reverseOrder={false} toastOptions={{ style: { marginBottom: "40px", maxWidth: "450px", background: '#444', color: '#fff', borderRadius: '10px' } }} limit={3} />

      <motion.div key={location.pathname} initial={{ opacity: 0.5 }} transition={{ duration: 0.1 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} >
        <main>
          <Outlet />
        </main>

      </motion.div>
      <ScrollRestoration />
      <Footer />
    </>
  );
}

export default App;

